import {
  InsightResponseType,
  InsightType,
  MultiSelectInsightOption,
} from 'dashboard/models/document';

export type InsightPanelForm = {
  insightName: string;
  insightKey: string;
  insightType: InsightType;
  responseType: InsightResponseType;
  instruction: string;
  options: MultiSelectInsightOption[];
  defaultResponse: string;
  saveToDocumentField: boolean;
  isNewDocumentField: boolean;
  documentFieldName: string;
  documentFieldKey: string;
};

export const INSIGHT_TYPE_TO_DISPLAY_NAME: Record<InsightType, string> = {
  [InsightType.String]: 'String',
  [InsightType.MultiSelect]: 'Multiple choice',
};

export const INSIGHT_TYPE_TO_DESCRIPTION: Record<InsightType, string> = {
  [InsightType.String]: 'Conversational or unstructured answer',
  [InsightType.MultiSelect]: 'Pick from a custom list of possible answers',
};

export const RESPONSE_TYPE_TO_DISPLAY_NAME: Record<InsightResponseType, string> = {
  [InsightResponseType.Single]: 'Best answer',
  [InsightResponseType.Multiple]: 'All answers',
};

export const RESPONSE_TYPE_TO_DESCRIPTION: Record<InsightResponseType, string> = {
  [InsightResponseType.Single]: 'Pick 1 answer from a list',
  [InsightResponseType.Multiple]: 'Pick multiple answers from a list',
};
